// extracted by mini-css-extract-plugin
export default {"notesarea":"NotesName_notesarea__h7lmy","profile":"NotesName_profile__L6J7X","groupName":"NotesName_groupName__FqRgE","margin":"NotesName_margin__q98Pj"};